import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  Container, 
  Typography, 
  Box,
  Paper,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Button
} from '@mui/material';
import welcomeImage from './img/welcome2.png';

function Mensagem() {
  const [visitantes, setVisitantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const buscarVisitantes = async () => {
      try {
        const response = await axios.get('https://tibmacae.org.br/listar-visitantes.php');
        setVisitantes(response.data);
      } catch (error) {
        setError('Erro ao carregar lista de visitantes');
        console.error('Erro:', error);
      } finally {
        setLoading(false);
      }
    };

    buscarVisitantes();
  }, []);

  const abrirWhatsApp = (nome, telefone) => {
    if (!telefone || telefone.trim() === '') {
      alert('Este visitante não possui número de telefone cadastrado.');
      return;
    }
    const mensagemPadrao = encodeURIComponent("Olá! Que bom ter você conosco na Terceira Igreja Batista de Macaé. Seja muito bem-vindo(a)!");
    const numeroFormatado = telefone.replace(/\D/g, ''); // Remove caracteres não numéricos
    window.open(`https://wa.me/55${numeroFormatado}?text=${nome}, ${mensagemPadrao}`, '_blank');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${welcomeImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth={false} 
      sx={{ 
        position: 'relative', 
        zIndex: 2 ,
        width: {
            xs: '100%', // 80% da largura em telas de celular
            sm: '100%'  // mantém 80% em telas maiores
          }
    }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(8px)',
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}
        >
          <Typography 
            variant="h4" 
            component="h1" 
            sx={{ 
              fontFamily: "'Great Vibes', cursive",
              fontWeight: 700,
              color: '#FFFFFF',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              letterSpacing: '1px',
              textAlign: 'center',
              mb: 4,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '3px',
                background: 'linear-gradient(90deg, transparent, #FFFFFF, transparent)',
              }
            }}
          >
            Enviar Mensagem
          </Typography>

          {loading ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress sx={{ color: '#FFFFFF' }} />
            </Box>
          ) : error ? (
            <Typography color="error" align="center" sx={{ color: '#FF6B6B', textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}>
              {error}
            </Typography>
          ) : (
            <List sx={{ 
              maxHeight: '60vh', 
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '4px',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.5)',
                },
              },
            }}>
              {visitantes.map((visitante, index) => (
                <ListItem 
                  key={index} 
                  divider
                  onClick={() => abrirWhatsApp(visitante.nome, visitante.telefone)}
                  sx={{
                    transition: 'all 0.3s ease',
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      transform: 'translateX(5px)',
                    },
                    padding: '16px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          fontFamily: "'Playfair Display', serif",
                          fontWeight: 700,
                          fontSize: {
                            xs: '1.1rem', // tamanho padrão para celular
                            sm: '2.2rem',
                            xl: '5.2rem',  // dobro do tamanho para telas maiores que celular
                            xxl:'8.2rem'
                          },
                          color: '#FFFFFF',
                          letterSpacing: '0.5px',
                          marginBottom: '4px',
                          textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
                        }}
                      >
                        {visitante.nome}
                      </Typography>
                    }
                    secondary={
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          fontFamily: "'Dancing Script', cursive",
                          fontSize: '1.1rem',
                          color: 'rgba(255, 255, 255, 0.9)',
                          marginLeft: '8px',
                          textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                        }}
                      >
                        {/* Clique para enviar mensagem via WhatsApp */}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Paper>
      </Container>
    </Box>
  );
}

export default Mensagem;